/* HatShOe mobiel menu. Hangt aan de bestaande knop .mobile-hembuger. */
(function () {
  function init() {
    var nav = document.getElementById('HsMobileNav');
    if (!nav) return;

    var viewport = nav.querySelector('.hsnav__viewport');
    var stack = ['root'];

    function toon(id) {
      var panels = nav.querySelectorAll('[data-hsnav-panel]');
      for (var i = 0; i < panels.length; i++) {
        var actief = panels[i].getAttribute('data-hsnav-panel') === id;
        if (actief) {
          panels[i].classList.add('is-active');
        } else {
          panels[i].classList.remove('is-active');
        }
      }
      if (viewport) viewport.scrollTop = 0;
    }

    function openen(e) {
      if (window.innerWidth >= 990) return;
      if (e) e.preventDefault();
      stack = ['root'];
      toon('root');
      nav.removeAttribute('hidden');
      document.documentElement.classList.add('hsnav-open');
    }

    function sluiten() {
      nav.setAttribute('hidden', '');
      document.documentElement.classList.remove('hsnav-open');
    }

    var knoppen = document.querySelectorAll('.mobile-hembuger');
    for (var k = 0; k < knoppen.length; k++) {
      knoppen[k].addEventListener('click', openen);
    }

    nav.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var opener = target.closest('[data-hsnav-open]');
      if (opener) {
        e.preventDefault();
        stack.push(opener.getAttribute('data-hsnav-open'));
        toon(stack[stack.length - 1]);
        return;
      }
      if (target.closest('[data-hsnav-back]')) {
        e.preventDefault();
        if (stack.length > 1) stack.pop();
        toon(stack[stack.length - 1]);
        return;
      }
      if (target.closest('[data-hsnav-close]')) {
        e.preventDefault();
        sluiten();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !nav.hasAttribute('hidden')) sluiten();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990 && !nav.hasAttribute('hidden')) sluiten();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
